export default "__VITE_ASSET__CuiEo3lF__";